'use strict';

var _toConsumableArray = require("/Users/andrejgoncarenko/WebstormProjects/knackly/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _classCallCheck = require("/Users/andrejgoncarenko/WebstormProjects/knackly/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/Users/andrejgoncarenko/WebstormProjects/knackly/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var Scope = require('./yobj');
var OD = require('./fieldtypes');
var base = require('./base-templater');
var MetaEvaluator = /*#__PURE__*/function () {
  function MetaEvaluator(scope) {
    _classCallCheck(this, MetaEvaluator);
    this.missing = {};
    this.errors = [];
    this.contextStack = scope && scope.__yobj ? scope.__yobj : scope instanceof Scope ? scope : Scope.pushObject(scope);
  }
  _createClass(MetaEvaluator, [{
    key: "assemble",
    value: function assemble(contentArray) {
      var _this = this;
      var result = contentArray.map(function (contentItem) {
        return _this.ContentReplacementTransform(contentItem, _this.contextStack);
      });
      // reset context stack (a TextEvaluator is a one-time-use sort of thing)
      this.contextStack = null;
      return FlatSingle(result);
    }
  }, {
    key: "ContentReplacementTransform",
    value: function ContentReplacementTransform(contentItem, contextStack) {
      var _this2 = this;
      if (!contentItem || typeof contentItem === 'string') {
        return;
      }
      if (typeof contentItem !== 'object') {
        throw new Error("Unexpected content '".concat(contentItem, "'"));
      }
      var frame = contextStack; // .peek()
      switch (contentItem.type) {
        case OD.Content:
          try {
            var evaluator = base.compileExpr(contentItem.expr);
            return frame.deferEvaluate(evaluator);
          } catch (err) {
            return CreateContextErrorMessage(err.message);
          }
        case OD.List:
          {
            var iterable;
            try {
              var _evaluator = base.compileExpr(contentItem.expr);
              // todo: make sure the following is memoized to avoid unnecessary re-evaluation
              iterable = frame.evaluate(_evaluator);
            } catch (err) {
              return CreateContextErrorMessage(err.message);
            }
            contextStack = Scope.pushList(iterable, contextStack);
            contextStack.__expr = contentItem.expr; // for deferred re-evaluation of list if necessary
            var allContent = contextStack.indices.map(function (index) {
              contextStack = Scope.pushListItem(index, contextStack);
              contextStack.__index = index; // for deferred re-selection of list item if necessary
              var listItemContent = contentItem.contentArray.map(function (listContentItem) {
                return _this2.ContentReplacementTransform(listContentItem, contextStack);
              });
              contextStack = Scope.pop(contextStack);
              return FlatSingle(listItemContent);
            });
            contextStack = Scope.pop(contextStack);
            return FlatSingle(allContent);
          }
        case OD.If:
        case OD.ElseIf:
          {
            var bValue;
            try {
              if (frame.frameType === Scope.LIST) {
                throw new Error("Internal error: cannot define a condition directly in a ".concat(frame.frameType, " context"));
              }
              var _evaluator2 = base.compileExpr(contentItem.expr);
              // todo: make sure the following is memoized to avoid unnecessary re-evaluation
              var value = frame.evaluate(_evaluator2);
              bValue = Scope.isTruthy(value);
            } catch (err) {
              return CreateContextErrorMessage(err.message);
            }
            if (bValue) {
              var content = contentItem.contentArray.filter(function (item) {
                return typeof item !== 'object' || item == null || item.type !== OD.ElseIf && item.type !== OD.Else;
              }).map(function (conditionalContentItem) {
                return _this2.ContentReplacementTransform(conditionalContentItem, contextStack);
              });
              return FlatSingle(content);
            }
            var elseCond = contentItem.contentArray.find(function (item) {
              return typeof item === 'object' && item != null && (item.type === OD.ElseIf || item.type === OD.Else);
            });
            if (elseCond) {
              if (elseCond.type === OD.ElseIf) {
                return this.ContentReplacementTransform(elseCond, contextStack);
              }
              // else
              var _content = elseCond.contentArray.map(function (conditionalContentItem) {
                return _this2.ContentReplacementTransform(conditionalContentItem, contextStack);
              });
              return FlatSingle(_content);
            }
          }
          break;
      }
    }
  }]);
  return MetaEvaluator;
}();
module.exports = MetaEvaluator;
function FlatSingle(arr) {
  var _ref;
  return (_ref = []).concat.apply(_ref, _toConsumableArray(arr)).filter(Boolean);
}
function CreateContextErrorMessage(message) {
  return {
    error: 'Evaluation Error: ' + message
  };
}